import { generateClient } from "aws-amplify/api";
import { askAIForQuestion } from "@/graphql/mutations";
const client = generateClient();
export const AskAIForResponse = {
  methods: {
    async AskAIForResponseMethod(user_prompt) {
      try {
        let result = await client.graphql({
          query: askAIForQuestion,
          variables: {
            input: {
              user_prompt,
            },
          },
        });
        var ResultObj = JSON.parse(result.data.askAIForQuestion);
        if (ResultObj.status == 200 || ResultObj.status === "SUCCESS") {
          return ResultObj.result;
        }
        return "";
      } catch (error) {
        this.noDataText = error.errors[0].message;
        console.log("Error", error);
        return "";
      }
    },
  },
};
